module.exports = require('../package.json').version;



//////////////////
// WEBPACK FOOTER
// /home/jenkins/workspace/production-argos-front/argos/node_modules/websocket/lib/version.js
// module id = j/2k
// module chunks = 5